
import page from "~/layouts/testimonial.vue";

export default {
  components: {
    page,
  },

  head() {
    return {
      title: "Campagne Réseaux Sociaux pour boutique de prêt à porter | ALEO",
      meta: [
        {
          hid: "description",
          name: "description",
          content:
            "La Faute à Voltaire a fait confiance à ALEO pour une stratégie permettant d'optimiser sa présence sur les réseaux sociaux et de mettre en avant son travail.",
        },
        {
          hid: "og:title",
          property: "og:title",
          content: "Réseaux sociaux",
        },
        {
          hid: "og:description",
          property: "og:description",
          content: "La Faute à Voltaire",
        },
      ],
    };
  },
};
